module.exports = __webpack_public_path__ + "static/img/eth.a63e7b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/eth.png
// module id = I2bn
// module chunks = 1